import React, { memo, forwardRef, useCallback } from 'react';
import InputRefMC from './InputRefMC';
import { sharingInformationService } from '../../../../services/sharingInformationService';

/**
 * Componente input optimizado que usa el FormContext compartido
 * pero con lógica propia para evitar re-renders del padre
 */
const ChatInputMC = memo(forwardRef(({
  maxChars,
  placeholder,
  onTextChange,
  setSelectedFastAnswer,
  setSelectedProduct,
  handleKeyDown
}, ref) => {
  // Memoizar el onChange para evitar recreación en cada render
  const handleChange = useCallback((fieldName, value) => {
    const textLength = (value || '').trim().length;
    sharingInformationService.setSubject({
      isTypingInComposer: textLength > 0,
      textLength
    });

    // Limpiar fast answer si el input está vacío
    if (setSelectedFastAnswer) {
      if (!value || value.trim() === '') {
        setSelectedFastAnswer(null);
      }
    }
    // Limpiar producto seleccionado si el input está vacío
    if (setSelectedProduct) {
      if (!value || value.trim() === '') {
        setSelectedProduct(null);
      }
    }
    if (onTextChange) {
      onTextChange(fieldName, value);
    }
  }, [onTextChange, setSelectedFastAnswer, setSelectedProduct]);

  const onKeyDownInternal = useCallback((e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      sharingInformationService.setSubject({
        isTypingInComposer: false,
        textLength: 0
      });
    }
    if (handleKeyDown) {
      handleKeyDown(e);
    }
  }, [handleKeyDown]);

  return (
    <div className="tw-relative tw-flex-1 tw-min-w-0 tw-h-full tw-pl-1">
      <InputRefMC
        textarea
        hideBorder
        rows={3}
        maxLength={maxChars}
        name="message"
        placeholder={placeholder}
        ref={ref}
        onChange={handleChange}
        onKeyDown={onKeyDownInternal}
        containerClass="tw-flex-1 tw-min-w-0"
        className="tw-flex-1 tw-min-w-0 tw-resize-none tw-placeholder-gray-400 focus:tw-ring-0 focus:tw-border-transparent focus:tw-shadow-none focus:tw-outline-none focus:tw-ring-transparent focus:tw-border-0 !tw-py-1"
      />
      <span className="tw-absolute tw-top-0 tw-bottom-0 tw-right-0 tw-w-[3px] tw-bg-gray-300" style={{ height: '100%' }}></span>
    </div>
  );
}), (prevProps, nextProps) => (
  // Comparación personalizada para memo más agresivo
  prevProps.maxChars === nextProps.maxChars
  && prevProps.placeholder === nextProps.placeholder
  && prevProps.onTextChange === nextProps.onTextChange
  && prevProps.setSelectedFastAnswer === nextProps.setSelectedFastAnswer
));

ChatInputMC.displayName = 'ChatInputMC';

export default ChatInputMC;
